import React from 'react'

const SVG = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 98 8"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M98 4C98 1.79086 96.2091 0 94 0H0V8H94C96.2091 8 98 6.20914 98 4Z"
      fill={fill}
    />
  </svg>
);

export default SVG


